function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 19"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.807 19 12 16.807l-7.124-7.14L12 2.527 9.807.334.473 9.667z",
    style: {
      fill: "currentColor"
    }
  }));
};
export { SvgArrowLeft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTIgMTkiCiAgICB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogICAgPHN0eWxlPgogICAgICAuaWNvbiB7CiAgICAgICAgZmlsbDogY3VycmVudENvbG9yOwogICAgICB9CiAgICA8L3N0eWxlPgogICAgPHBhdGggY2xhc3M9Imljb24iIGQ9Ik05LjgwNjY3IDE5LjAwMDJMMTIgMTYuODA2OUw0Ljg3NTU2IDkuNjY2OTFMMTIgMi41MjY5MUw5LjgwNjY3IDAuMzMzNTc2TDAuNDczMzM0IDkuNjY2OTFMOS44MDY2NyAxOS4wMDAyWiIgLz4KPC9zdmc+";